import React, { PureComponent } from 'react';

const ReceptorNacional = ({ data = {} }) => {
  return (
    <div>
      { data.NomDenRazSocR }
      <br/>

      <div className="pt-2">
        <span>RFC: </span>
        { data.RFCRecep || data.RfcR }
        <br/>

        <span>CP: </span>
        { data.cp || data.DomicilioFiscalR || data.direccion?.cp }
        <br/>

        <span>Email: </span>
        { data.Email }
        <br/>
      </div>
    </div>
  )
}

const ReceptorExtranjero = ({ data = {} }) => {
  return (
    <div>
      { data.NomDenRazSocR }
      <br/>

      <div className="pt-2">
        <span>Reg ID tributario: </span>
        { data.NumRegIdTrib || data.NumRegIdTribR }
        <br/>

        <span>Email: </span>
        { data.Email }
        <br/>
      </div>
    </div>
  )
}

class ReceptorSelected extends PureComponent {

  render() {
    const { data } = this.props;

    return (
      <>
        { data.NacionalidadR === 'Nacional' && <ReceptorNacional data={ data.Nacional } /> }
        { data.NacionalidadR === 'Extranjero' && <ReceptorExtranjero data={ data.Extranjero } /> }
      </>
    )
  }
}

export default ReceptorSelected;